import _ from "@/boot/lodash";
import store from "@/store";
import router from "@/router";
import { ToastProgrammatic as $toast } from "buefy";
import { NavigationGuardNext, Route } from "vue-router";

export default [
  {
    path: "/auth",
    redirect: "/login",
    component: () => import("@/skeleton/client/loggedOut/index.vue"),
    beforeEnter: async (to: Route, from: Route, next: NavigationGuardNext) => {
      if (
        store.getters["auth/client/isAuthenticated"] &&
        !store.getters["auth/client/isGuestCustomerAuthenticated"]
      ) {
        store.dispatch("ui/endRouting");
        return next(from.path === "/" ? "/" : false);
      }
      store.commit("user", {});
      /** Here we try 'brand/get' again incase the user has been routed from the
       * admin area where a different brand was loaded in memory (possible with
       * multi-brand orgs). In most cases this dispatch won't result in any
       * additonal network calls as brand data will be returned from store.
       * */
      await store.dispatch("brand/get", {
        ignoreStored: from.path.startsWith("/admin")
      });
      // Continue with routing
      next();
    },
    children: [
      {
        path: "login",
        alias: "/login",
        name: "clientLogin",
        component: () => import("@/views/client/auth/login/index.vue"),
        meta: {
          title: "_.login",
          group: "auth"
        }
      },
      {
        path: "forgotten-password",
        alias: "/forgotten-password",
        name: "forgottenPassword",
        component: () =>
          import("@/views/client/auth/forgottenPassword/index.vue"),
        meta: {
          title: "_.recover_account"
        }
      },
      {
        path: "reset-password",
        alias: "/reset-password",
        component: () => import("@/views/client/auth/resetPassword/index.vue"),
        meta: {
          title: "_.reset_password"
        }
      },

      {
        path: "register",
        alias: "/register",
        name: "clientRegister",
        component: () => {
          // Org registration
          if (store.getters.isUpmindContext)
            return import("@/views/client/auth/registerOrg/index.vue");
          // Client registration
          return import("@/views/client/auth/register/index.vue");
        },
        meta: {
          title: "_.create_account",
          group: "auth"
        }
      }
    ]
  },
  {
    path: "/logout",
    name: "clientLogout",
    beforeEnter(to, from, next) {
      const query = {};
      const fullPath = window.location.pathname + window.location.search;
      if (!fullPath.startsWith("/logout")) query["redirect"] = fullPath;
      if (from.matched.length) {
        const message = _.get(to.params, "toast");
        if (message) $toast.open({ message });
      }
      next();
      router.replace({ query }).catch(err => err);
    },
    component: {
      name: "ClientLogout",
      async created() {
        await store.dispatch("auth/logout", "client");
        const query = router.currentRoute.query;
        router.replace({ name: "clientLogin", query }).catch(err => err);
      },
      render(h) {
        return h("loading", {
          props: {
            centered: true
          }
        });
      }
    }
  }
];
